$(document).foundation();

$(document).ready(function () {
	// utils
	initVerticalCenter();
	initAnimateInView();
	inlineSVGs([
		'.header__contact img',
		'.footer__social img',
		'.off-canvas__social img',
		'.blog-post__share img'
	]);
	
	// global
	initHeader();
	initNotification();
	initOffCanvas();
	initNewsletter();
	initSliders();
	initBackToTop();
	initPopup();
	//initSwirls();
	
	// template specific
	initAnchors();
	initHighlights();
	initAccordion();
	initFilters();
	initCaseStudy();
	initPeople();
	initListing();
	initFileUpload();
	initBlogPost();
	initWork();
});



function initVerticalCenter() {
	$('.vertical-center').each(function () {
		$(this).wrapInner('<div class="vertical-center-table"><div class="vertical-center-row"><div class="vertical-center-cell"></div></div></div>');
	});
}



function initAnimateInView() {
	$(window).on('DOMContentLoaded load resize scroll', animateElementsInView);
	animateElementsInView();
}

function animateElementsInView() {
	$('[data-animate-in-view]').each(function () {
		//console.log($(this));
		if ( isElementInViewport($(this)) ) {
			$(this).addClass( $(this).data('animate-in-view') );
		}
	});
}

// https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
function isElementInViewport (el) {
	//special bonus for those using jQuery
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}

	var rect = el.getBoundingClientRect();

	var t = rect.y;
	var b = window.innerHeight - rect.y - rect.height;
	var h = window.innerHeight;

	if (
		( (t >= 0) && (t <= h) ) ||
		( (b >= 0) && (b <= h) )
	) {
		return true;
	} else {
		return false;
	}
}



// https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
function inlineSVGs(inputValue) {
	var selectorString = '';
	if (typeof inputValue === "object") {
		selectorString = inputValue.join(',');
	} else {
		selectorString = inputValue;
	}

	$(selectorString).each(function () {
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		if (imgURL.indexOf('.svg') > -1) {
			$.get(imgURL, function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');

				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg');
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');

				// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
				if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
					$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
				}

				// Replace image with new SVG
				$img.replaceWith($svg);
			}, 'xml');
		}
	});
}



function pad(n, width, z) {
	z = z || '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last,
		  deferTimer;
	  return function () {
		var context = scope || this;
	
		var now = +new Date,
			args = arguments;
		if (last && now < last + threshhold) {
		  // hold on to it
		  clearTimeout(deferTimer);
		  deferTimer = setTimeout(function () {
			last = now;
			fn.apply(context, args);
		  }, threshhold);
		} else {
		  last = now;
		  fn.apply(context, args);
		}
	  };
	}


function initHeader() {
	

	// Detect if the header is over and image slider, if yes then give it a transparent background
	setHeaderTransparency();
	$(window).on('scroll', setHeaderTransparency);

	function setHeaderTransparency() {
		if (window.pageYOffset < 150) {
			$('.header').removeClass('header--scrolled');
		} else {
			$('.header').addClass('header--scrolled');
		}
	}
	
	// Show the burger nav when there isn't enough room for the horizontal nav
	if ( $('.slider').length === 0 ) {
		$('.header').addClass('header--solid')
	}
	
	
	$('.header__lang').accordiom({
		showFirstItem: false
	});
}



function initOffCanvas() {
	//$('#offCanvas').foundation('open');
	
	// Wait for this to init and then show the open burger menu button
	var offCanvasInit = setInterval(showOffCanvas, 100);
	
	function showOffCanvas() {
		if ( $('#offCanvas').hasClass('is-closed') ) {
			clearInterval(offCanvasInit);
			$('.header__open-off-canvas').addClass('visible');
		}
	}
	
	$('.off-canvas__primary > ul > li').each(function () {
		// Automatically add the "Overview" links to the landing page
		if ( $(this).find('ul').length > 0 ) {
			var overviewLink = $(this).find('a').first().attr('href');
			$(this).find('ul').prepend('<li><a href="' + overviewLink + '">Overview</a></li>');
		}
	});
	
	
	$('.off-canvas__primary > ul > li > a').on('click', function () {
		if ( $(window).innerWidth() >= 640 ) return; // ignore tablet+ sizes
		
		if ( $(this).next('.off-canvas__primary-sub').length > 0 ) { // only trigger if there are sub pages to show
			if ( $(this).parent().hasClass('open') ) {
				// second click of main item allows clicking directly through
				return true;
			} else {
				// close any other open items
				$('.off-canvas__primary > ul > li.open').removeClass('open').find('.off-canvas__primary-sub').slideUp();
				
				// and open the new one
				$(this).parent().addClass('open');
				$(this).next().slideDown();
			}
			return false; // prevent navigating
		}
	});
	
	
	// Clicking on anchor links in the already active page should close the burger and trigger the actual anchor button
	$('.off-canvas__primary-sub a').on('click', function () {
		if ( $(this).attr('href').indexOf('#') > -1 ) {
			var pageURL = $(this).attr('href').split('#')[0];
			var anchorLink = $(this).attr('href').split('#')[1];
			
			// Only trigger if we're already on the main page
			if ( window.location.pathname == pageURL ) {
				$('#offCanvas').removeClass('is-open');
				//$('.anchors').find('a[href="#' + anchorLink + '"]').trigger('click');
				
				$('[data-animate-in-view]').each(function () {
					//$(this).addClass( $(this).data('animate-in-view') );
					$(this).addClass('transition--none').removeClass('transform--will-slide-in transform--will-slide-in-right transform--will-fade-in transform--will-fade-up transform--will-fade-down transform--will-fade-left transform--will-fade-right');
				});
				
				var scrollToPos = $('a[name="' + anchorLink + '"]').offset().top;
						
				if (typeof scrollToPos !== 'undefined') {
					scrollToPos -= $('.header').outerHeight();
					scrollToPos -= 40;
					
					$('html, body').animate({
						scrollTop: scrollToPos
					}, 0);
				}
				return false;
			}
		}
	});
}

function initNotification() {
	if ( $('.notification').length > 0 ) {
		$('body').addClass('has-notification');
	}
	
	$('.notification__toggle').on('click', function () {
		$('.notification').toggleClass('open');
	});
	
	// Set the sizing of the vertical text in the button
	if ( $(window).innerWidth() >= 640 ) {
		$('.notification__toggle span').css('width', $('.notification__panel').outerHeight() + 'px');
	} else {
		$('.notification__toggle span').attr('style', '');
	}
	
	// Allow clicking outside to close
	$(document).on('click', function (e) {
		if ( ($('.notification').hasClass('open')) && (!$(e.target).hasClass('notification__toggle')) ) {
			$('.notification').removeClass('open');
		}
	});
}


function initNewsletter() {
	var count = 0;
	$('.form__checkbox').each(function () {
		$(this).find('input').attr('id', 'newsletter_consent_' + count);
		$(this).find('label').attr('for', 'newsletter_consent_' + count);
		count++;
	});
	
	$('.newsletter form, .listing__careers-form form, .job__application-form').on('submit', function () {
		// Set a cookie with the current scroll position so that we can get back to this point after the form submits
		Cookies.set('form_scroll_position', window.pageYOffset, { expires: 1 });
	});
	
	// Scroll back to the last position before submitting if the cookie is there
	if ( Cookies.get('form_scroll_position') ) {
		$('html, body').animate({
			scrollTop: Cookies.get('form_scroll_position')
		}, 0);
		
		Cookies.remove('form_scroll_position');
	}
}



/**
 * Scales any element to simulate the CSS background-size: cover property.
 * @param {DOMelement} element The element to scale
 * @param {bool} [scaleToParent] Scale the element to fill the parent instead
 *                               of the whole browser window.
 */
function coverViewport(element, scaleToParent) {
	if (typeof scaleToParent === 'undefined') { scaleToParent = false; }

	var viewportWidth, viewportHeight;
	if (scaleToParent) {
		viewportWidth = $(element).parent().innerWidth();
		viewportHeight = $(element).parent().innerHeight();
	} else {
		viewportWidth = $(window).innerWidth();
		viewportHeight = $(window).innerHeight();
	}

	var $element = $(element);

	var elementWidth = $element.attr('width');
	var elementHeight = $element.attr('height');

	// Aspect ratio = height / width
	var viewportRatio = viewportHeight / viewportWidth;
	var videoRatio = elementHeight / elementWidth;

	//console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);


	var newWidth = (elementWidth / elementHeight) * viewportHeight
	var newHeight = (elementHeight / elementWidth) * viewportWidth;
	var newTop = 0;

	if (viewportRatio > videoRatio) {
		// set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
		//console.log('crop left and right');
		$element.css('height', viewportHeight);
		$element.css('width', newWidth);
		$element.css('left', '-' + (newWidth - viewportWidth) / 2 + 'px');
		$element.css('top', '0');
	} else if (viewportRatio < videoRatio) {
		// set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
		//console.log('crop top and bottom');
		$element.css('width', viewportWidth);
		$element.css('height', newHeight);
		$element.css('left', '0');
		$element.css('top', '-' + (newHeight - viewportHeight) / 2 + 'px');
	} else {
		// set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
		//console.log('no crop');
		$element.css('height', viewportHeight);
		$element.css('width', viewportWidth);
		$element.css('left', '0');
		$element.css('top', '0');
	}
}



function initSliders() {
	$('.slider__inner').reformSlider({
		arrows: false,
		pagination: true,
		autoPlay: true,
		speed: 6000
	});
	
	if ($('.slider__video').length > 0) {
		$('.slider').addClass('has-video');		
		coverViewport($('.slider__video iframe'), true);
		$(window).on('resize', function () {
			coverViewport($('.slider__video iframe'), true);
		});
	}
}



function initBackToTop() {
	$('main').append('<div class="back-to-top"><div class="back-to-top__inner"><button>Back to top</button></div></div>');
	
	$('.back-to-top button').on('click', function () {
		$('html, body').animate({
			scrollTop: 0
		}, 1000);
	});
	
	setBackToTopVisibility();
	$(window).on('scroll', setBackToTopVisibility);

	function setBackToTopVisibility() {
		// Only show the button when the user has scrolled more than 2 screenheightsworth
		if (window.pageYOffset > (window.innerHeight * 2)) {
			$('.back-to-top').addClass('visible');
		} else {
			$('.back-to-top').removeClass('visible');
		}
		
		// Prevent the button from overlapping the footer if the user has scrolled almost the whole way
		if ( window.pageYOffset > ( $('main').outerHeight() - window.innerHeight ) ) {
			$('.back-to-top').css('position', 'absolute');
		} else {
			$('.back-to-top').attr('style', '');
		}
	}
}


function initAnchors() {
	// Clickable anchors
	$('.anchors a').on('click', function (e) {
		e.preventDefault();
		
		var anchorName = $(this).attr('href').replace('#', '');
		
		// Need to complete all animations before scrolling position can be found
		$('[data-animate-in-view]').each(function () {
			//$(this).addClass( $(this).data('animate-in-view') );
			$(this).addClass('transition--none').removeClass('transform--will-slide-in transform--will-slide-in-right transform--will-fade-in transform--will-fade-up transform--will-fade-down transform--will-fade-left transform--will-fade-right');
		});
		
		var scrollToPos = $('a[name="' + anchorName + '"]').offset().top;
				
		if (typeof scrollToPos !== 'undefined') {
			scrollToPos -= $('.header').outerHeight();
			scrollToPos -= 40;
			
			$('html, body').animate({
				scrollTop: scrollToPos
			}, 1000);
		}
	});
	
	
	
	
	// Nicely scroll if deep linked to an anchor
	if ( window.location.hash !== '' ) {
		$('.anchors a[href="' + window.location.hash + '"]').trigger('click');
		
		$('[data-animate-in-view]').each(function () {
			$(this).addClass( $(this).data('animate-in-view') );
		});
		
		var anchorName = window.location.hash.replace('#', '');
		anchorName = anchorName.replace('%20', ' ');
		if ( $('a[name="' + anchorName + '"]').length === 0 ) {
			return;
		}
		
		// Delay to allow for scrolling animations
		var waitForAnimations = 1500;
		if ( $('.contact__details').length > 0 ) {
			waitForAnimations = 0;
		}
		
		setTimeout(function () {
			var scrollToPos = $('a[name="' + anchorName + '"]').first().parent().offset().top;
			
			if (typeof scrollToPos !== 'undefined') {
				scrollToPos -= $('.header').outerHeight();
				//scrollToPos += 100;
			
			
				$('html, body').animate({
					scrollTop: scrollToPos
				}, 0);
			}
		}, waitForAnimations);
	}
}


function initHighlights() {
	$('.highlights__carousel').slick({
		arrows: false,
		dots: true,
		slidesToShow: 3,
		infinite: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
}


function initAccordion() {
	$('.accordion__wrapper').accordiom();
}



function initFilters() {
	$('.filter').accordiom({
		showFirstItem: false,
		afterChange: function (accordionButton) {
			// Make all block items visible if a filter is opened
			$('[data-animate-in-view]').each(function () {
				$(this).addClass( $(this).data('animate-in-view') );
			});
		}
	});
	
	
	$('.people__filter .filter__clear button').on('click', function () {
		$('.filter__list button.all').trigger('click');
	});
	
	$('.filter button[data-filter-category=""], .filter button[data-filter-tag=""]').remove(); // take out blank buttons
	
	
	// Allow for pre-filtering based on URL
	if ( window.location.hash !== '' ) {
		var hashString = window.location.hash.replace('#', '');
		hashString = decodeURIComponent(hashString);
		var hashParts = hashString.split('|');
		
		var count = 0;
		for ( var i=0; i < hashParts.length; i++ ) {
			if ( $('.filter__list button[data-filter-category="' + hashParts[i] + '"]' ).length > 0) {
				count++;
			}
			$('.filter__list button[data-filter-category="' + hashParts[i] + '"]').trigger('click');
			
			if ( $('.filter__list button[data-filter-tag="' + hashParts[i] + '"]' ).length > 0) {
				count++;
			}
			$('.filter__list button[data-filter-tag="' + hashParts[i] + '"]').trigger('click');
		}
		
		// Open the filters panel if there's at last one matching filter
		if (count > 0) {
			$('.filter .accordionButton').trigger('click');
		}
	}
}




function initCaseStudy() {
	$('.case-study__slider, .blog-post__slider-inner').slick({
		fade: true,
		arrows: false,
		dots: true
	});
	
	alignCaseStudyContent();
	$(window).on('resize', alignCaseStudyContent);
	
	
	// Sticky text beside the long screenshot as the user scrolls down the page
	if ( $('.case-study__tall-image').length > 0 ) {
		stickyContent();
		/*$(window).on('resize', alignCaseStudyContent);
		$(window).on('scroll', alignCaseStudyContent);*/
		$(window).on('DOMContentLoaded load resize scroll', stickyContent);

	}
}

function alignCaseStudyContent() {
	// Apply negative top margin to this element only when there is enough space above
	$('.case-study__three-images').each(function () {
		if ( $(this).prev().hasClass('case-study__content-image-right') ) {
			var spaceAbove = 
				($(this).prev().find('.case-study__content-image-right-picture').outerHeight() - $(this).prev().find('.case-study__content-image-right-text').outerHeight())
				|| 0;

			
			if (spaceAbove < 1)
				return true; // skip if there's no space above
			
			var spaceInside = 
				($(this).find('case-study__three-images-heading').outerHeight() - $(this).find('case-study__three-images-heading h3').outerHeight())
				|| 0;
			
			if (spaceInside > 1)
				return true; // skip if there's no space inside
				
			var totalMargin = spaceAbove + spaceInside;		
			$(this).css('margin-top', '-' + totalMargin + 'px');
		}
	});
}


function stickyContent() {
	$('.case-study__tall-image').each( function () {
		var $container = $(this).find('.case-study__tall-image-text');
		var $stickyBit = $(this).find('.case-study__tall-image-text-sticky');
		
		// Reset and skip if the content is taller than the browser window
		if ( $stickyBit.outerHeight() > ( $(window).innerHeight() - $('.header').outerHeight() ) ) {
			$stickyBit.removeClass('stuck').css('transform', 'translateY(0)');
			return;
		}
		
		// Check that the scroll position is beyond the top of the container
		if ( window.pageYOffset > $container.offset().top - $('.header').outerHeight() ) {
			var stickyOffset = window.pageYOffset - $container.offset().top + $('.header').outerHeight();
			
			// Only apply the new offset before the content hits the bottom
			if ( stickyOffset < ( $container.outerHeight() - $stickyBit.outerHeight() ) ) {
				$stickyBit.addClass('stuck').css('transform', 'translateY(' + stickyOffset + 'px)');
			}
		}
	});
}





function initPeople() {
	if ($('.people').length === 0)
		return;

	findPeopleContentHeight();
	Foundation.onImagesLoaded($('.people__image img'), findPeopleContentHeight);
	$(window).on('resize', findPeopleContentHeight);

	$('.people__item').on('click', function () {
		findPeopleContentHeight();
		var $item = $(this);
		
		if ( $(this).hasClass('people__item--open') ) {
			// Close this item up
			$item.removeClass('people__item--open');
			$('.people__item:visible, .people__grid').attr('style', ''); // move all items back up
			$item.find('.people__bio').slideUp();
		} else {
			// Close any other open ones first
			$('.people__item--open .people__bio').slideUp();
			$('.people__item--open').removeClass('people__item--open');
			$('.people__item:visible, .people__grid').attr('style', ''); // move all items back up
			
			// Now open this one
			$item.addClass('people__item--open');
			$item.find('.people__bio').slideDown();
			
			var contentHeight = $item.find('.people__bio').data('height');
			// Push down the bottom of the grid so we don't overlap the footer
			$('.people__grid').css('padding-bottom', contentHeight + 'px');
			
			// Only push down items in the same column (i.e. left offset) as the item which is opened
			$item.nextAll('.people__item').each(function () {
				if ( $(this).offset().left === $item.offset().left ) {
					$(this).css('transform', 'translateY(' + contentHeight + 'px)');
				}				
			});
		}
	});
	
	$('.people').on('filter-changed', function () {
		$('.people__item--open').removeClass('people__item--open');
		$('.people__item, .people__grid').attr('style', ''); // move all items back up
		$('.people__bio').slideUp();
	});
}


// Find out how tall the content is to know how far to push the items below when it opens.
function findPeopleContentHeight() {
	$('.people__bio').each(function () {
		if ( (!$(this).parent().hasClass('people__item--open')) && ($(this).parent().is(':visible')) ) {
			$(this).show();
			
			$(this).css({
				position:   'absolute',
				visibility: 'hidden',
				display:    'block'
			});
			
			$(this).data('height', $(this).outerHeight());
			
			$(this).attr('style', '');
			$(this).hide();
		}
	});
}




function initBlogPost() {
	if ( $(window).innerWidth() >= 1260 ) {
		var leftMargin = ($(window).innerWidth() - 1260) / 2;
		$('.blog-post__quote').css('width', '100vw').css('margin-left', '-' + leftMargin + 'px');
	}
}



function initListing() {
	// Apply the right CTA class depending on the order of the item
	$('.listing__item:first-child, .listing__item:nth-child(4n+5), .listing__item:nth-child(3), .listing__item:nth-child(4n+7)').find('.button').addClass('button--royal-blue');
	
	
	$('.listing__carousel-inner').slick({
		arrows: false,
		dots: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
		]
	});
}



function initFileUpload() {
	$('.form__file-upload input[type="file"]').on('change', function () {
		
		var attachedFiles = $(this)[0].files;
		
		if ( typeof attachedFiles !== 'undefined' ) {
			var fileNames = '';
			for (var i = 0; i < attachedFiles.length; i++) {
				fileNames += attachedFiles[i].name + '<br />';
			}
			$('#form__file-upload-attachments').html('Attached: <br />' + fileNames);
		}
	});
}





function initPopup() {
	if ($('#popup').length > 0) {
		var popupDelay = $('#popup').data('popup-delay') || 0;
		var popupKeepHiddenFor = $('#popup').data('popup-keep-hidden-for-n-days') || 0;

		// Only show the popup if the cookie has not been seen, or always show it for testing in either local or remote markup
		if ( 
			(!Cookies.get('hasSeenPopup')) || 
			(location.hostname.indexOf('localhost') > -1) || 
			(location.hostname.indexOf('projects') > -1) 
		) {
			setTimeout(function() {
				$('#popup').foundation('open');

				if (popupKeepHiddenFor > 0) {
					Cookies.set('hasSeenPopup', 'true', { expires: popupKeepHiddenFor });
				}
			}, popupDelay);
		}
	}
}




function initSwirls() {
	if ( $('body').hasClass('template-homepage') ) {
		$('main').append(createSwirl('swirl-home.svg', '110vh', 1028));
		
	} else if ( $('body').hasClass('template-service-landing') ) {
		$('main').append(createSwirl('swirl-service-1.svg', '150vh', 1005));
		$('main').append(createSwirl('swirl-service-2.svg', '350vh', 1005));
		
	} else if ( $('body').hasClass('template-case-study') ) {
		$('main').append(createSwirl('swirl-case-study-1.svg', '150vh', 710));
		$('main').append(createSwirl('swirl-case-study-2.svg', '330vh', 1152));
		$('main').append(createSwirl('swirl-case-study-3.svg', '425vh', 1071));
		
	} else if ( $('body').hasClass('template-blog-list') ) {
		$('main').append(createSwirl('swirl-blog-list.svg', '125vh', 1028));
		
	} else if ( $('body').hasClass('template-blog-post') ) {
		$('main').append(createSwirl('swirl-blog-post-1.svg', '150vh', 794));
		$('main').append(createSwirl('swirl-blog-post-2.svg', '300vh', 1152));
		$('main').append(createSwirl('swirl-blog-post-3.svg', '500vh', 1071));
	}
}

function createSwirl(imageName, positionTop, desktopHeight) {
	var pathPrefix = '/';
	if ( 
		(location.href.indexOf('projects') > -1) ||
		(location.href.indexOf('localhost') > -1)) {
		pathPrefix = '';
	}
	var paddingRatio = (desktopHeight / 1260) * 100;
	return '<div class="swirl" style="background-image: url(' + pathPrefix + 'assets/img/' + imageName + '); top: ' + positionTop + '; padding-bottom: ' + paddingRatio + '%"></div>';
}



function initWork() {
	// Fix for touch screen devices
	$('.work__back').on('click', function () {
		if ( $('html').hasClass('whatinput-types-touch') ) {
			$(this).toggleClass('visible');
			
			if ( $(this).hasClass('visible') ) {
				return true;
			} else {
				return false;
			}
		}
	});
}

function initCaptcha(token) {
	$('.contact form').submit();
}

function initCareersCaptcha(token) {
	$('.listing__careers-form form').submit();
}

function initUploadCaptcha(token) {
	$('.job__section form').submit();
}

function initNewsletterCaptcha(token) {
	$('.newsletter form').submit();
}

function initDownloadCaptcha(token) {
	$('.blog-post__download-form form').submit();
}

